import { motion } from "framer-motion";
import { Logo } from "../components/Logo";
import { fadeUp, viewportOnce } from "../lib/motion";

const FINAL_IMG =
    "https://images.unsplash.com/photo-1674758978719-6121d8fbefb4?q=80&w=2400&auto=format&fit=crop";

const PilotFinalVisual = () => (
    <section
        data-testid="pilot-final-visual"
        className="relative overflow-hidden border-t border-white/10"
    >
        <div className="relative h-[70vh] min-h-[480px]">
            <img
                src={FINAL_IMG}
                alt="Contemporary South African residential architecture at dusk"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/40" />
            <div className="blueprint-bg blueprint-fade absolute inset-0 opacity-70" />

            <div className="relative flex h-full flex-col items-center justify-center px-6 text-center">
                <motion.p
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    DURBAN — SOUTH AFRICA
                </motion.p>
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    data-testid="pilot-tagline"
                    className="mt-8"
                >
                    <Logo className="h-20 w-auto mx-auto md:h-24" />
                </motion.div>
            </div>
        </div>
    </section>
);

export default PilotFinalVisual;
